"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.autoLayoutStepHashSchema = exports.autoLayoutJobMetadataUidSchema = exports.autoLayoutJobUidSchema = void 0;
const tslib_1 = require("tslib");
const zod_1 = tslib_1.__importDefault(require("zod"));
exports.autoLayoutJobUidSchema = zod_1.default.custom((s) => typeof s === "string" && s.startsWith("auto-layout-"));
exports.autoLayoutJobMetadataUidSchema = zod_1.default.custom((s) => typeof s === "string" && s.startsWith("auto-layout-") && s.endsWith("-metadata"));
exports.autoLayoutStepHashSchema = zod_1.default.custom((s) => typeof s === "string" && s.startsWith("auto-layout-step-sha256-"));
//# sourceMappingURL=identifiers.js.map